'use client'

import { ReactNode, createContext, useContext } from 'react'

const UserAgentDeviceTypeContext = createContext<string | undefined>(undefined)

export function useUserAgentDeviceType() {
  return useContext(UserAgentDeviceTypeContext)
}

type UserAgentDeviceTypeProviderProps = {
  userAgentDeviceType: string | undefined
  children?: ReactNode
}

export function UserAgentDeviceTypeProvider({
  children,
  userAgentDeviceType,
}: UserAgentDeviceTypeProviderProps) {
  return (
    <UserAgentDeviceTypeContext.Provider value={userAgentDeviceType}>
      {children}
    </UserAgentDeviceTypeContext.Provider>
  )
}
